<ng-container *ngIf="displayMenuButton">
  <li routerLinkActive="active">
    <a [routerLink]="['notifications']">
      <ng-container *ngIf="hasUnread$ | async; else bellIcon">
        <div class="bell-wrapper">
          <ng-lottie
            width="20px"
            height="20px"
            containerClass="notification-bell mr-xs"
            [options]="notificationOptions"
          ></ng-lottie>
        </div>
      </ng-container>
      <span class="link-text">{{ 'NOTIFICATIONS' | translate }}</span></a>
  </li>
</ng-container>
<ng-template #bellIcon>
  <bw-icon-legacy
    [iconName]="'icon-bell'"
    horizontalSpace="mr-xs"
  ></bw-icon-legacy>
</ng-template>
